import { useMediaQuery } from "usehooks-ts";

export const useIsDesktop = () => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  return { isDesktop };
};
